import './WhitePopUpStyles.css';

import { useTranslation } from 'react-i18next';

import VideoPlayer from '../../../platform/components/Video';
import useKeyboardAction from '../../hooks/useKeyboardAction';

function WhiteVideoPopUp({ title, video, onClose }) {
  const { t } = useTranslation();

  useKeyboardAction(() => {
    onClose();
  }, 'Escape');

  return (
    <div className="popup-overlay">
      <div
        className="popup-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="popup-title"
      >
        <h2 className="popup-title" id="popup-title">
          {title}
        </h2>
        <div className="popup-body">
          <div className="popup-text-container">
            <div className="video_container video">
              <VideoPlayer
                image="https://res.cloudinary.com/champion-health/image/upload/v1630603701/authors/images/video_bg.png"
                url={video}
                type="author"
              />
            </div>
          </div>
        </div>
        <button type="button" className="popup-cta-container" onClick={onClose}>
          <div className="popup-cta"> {t('AT007')}</div>
        </button>
      </div>
    </div>
  );
}

export default WhiteVideoPopUp;
